const resource = {
    resource_identifier_in_use: 'The API identifier {{indicator}} is already in use',
};
export default Object.freeze(resource);
